module.exports = {"430373001":"和平街道","430373002":"九华街道","430373200":"响水乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430373.json
// module id = 1954
// module chunks = 0